import { z } from 'zod';
import { idSchema } from './common.js';
import { householdSummarySchema } from './households.js';
/** Admin (D13) payloads. Owned by the households/admin work. */
export const adminListHouseholdsQuerySchema = z.object({
    q: z.string().trim().max(120).optional(),
    includeDisabled: z
        .enum(['true', 'false'])
        .transform((v) => v === 'true')
        .optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
export const adminHouseholdsResponseSchema = z.object({
    households: z.array(householdSummarySchema),
    total: z.number().int(),
});
export const adminDisableHouseholdRequestSchema = z.object({
    reason: z.string().trim().min(1).max(500),
});
export const auditLogEntrySchema = z.object({
    id: idSchema,
    householdId: idSchema.nullable(),
    userId: idSchema.nullable(),
    action: z.string(),
    entity: z.string(),
    entityId: z.string().nullable(),
    at: z.iso.datetime(),
    detail: z.unknown().optional(),
});
export const auditLogResponseSchema = z.object({ entries: z.array(auditLogEntrySchema) });
//# sourceMappingURL=admin.js.map